<app-navbar></app-navbar>
@if (isRouteLoading()) {
  <div class="app-loading-overlay" aria-live="polite">
    <app-loading-spinner [label]="i18n.t('common.loadingPage')"></app-loading-spinner>
  </div>
}
<main class="app-main">
  <router-outlet></router-outlet>
</main>
<footer #appFooter class="app-footer bg-white border-top" [class.app-footer-expanded]="isPageBottom()">
  <div class="container-fluid app-footer-layout">
    <span class="app-footer-copyright">
      {{ i18n.t('common.copyright') }}
      @if (appVersion) { <span class="app-footer-version">v{{ appVersion }}</span> }
    </span>
    <nav class="footer-legal-links d-flex flex-wrap gap-3" [attr.aria-label]="i18n.t('legal.footerNav')">
      <a class="footer-link-primary" routerLink="/terms">{{ i18n.t('legal.cguShort') }}</a>
      <a class="footer-link-primary" routerLink="/privacy">{{ i18n.t('legal.privacyShort') }}</a>
      <a class="footer-link-primary" routerLink="/cookies">{{ i18n.t('legal.cookiesShort') }}</a>
      <a class="footer-link-primary" routerLink="/about">{{ i18n.t('about.footerShort') }}</a>
      <a class="footer-link-primary" routerLink="/contact">{{ i18n.t('common.contact') }}</a>
      <a class="footer-link-secondary" routerLink="/mentions-legales">{{ i18n.t('legal.legalNoticeShort') }}</a>
      <a class="footer-link-secondary" routerLink="/cgv">{{ i18n.t('legal.cgvShort') }}</a>
      <a class="footer-link-secondary" routerLink="/data-deletion">{{ i18n.t('legal.dataDeletionShort') }}</a>
      <a class="footer-link-secondary" routerLink="/accessibility">{{ i18n.t('legal.accessibilityShort') }}</a>
    </nav>
    <span class="app-footer-tagline text-secondary">{{ i18n.t('common.footerTagline') }}</span>
  </div>
</footer>
<button
  class="back-to-top-button"
  type="button"
  [class.back-to-top-button-visible]="isBackToTopVisible()"
  [attr.aria-hidden]="!isBackToTopVisible()"
  [attr.tabindex]="isBackToTopVisible() ? 0 : -1"
  [attr.aria-label]="i18n.t('common.backToTop')"
  (click)="scrollToTop()">
  <i class="bi bi-arrow-up" aria-hidden="true"></i>
</button>
@if (isStorageNoticeVisible()) {
  <section class="storage-notice shadow-lg" role="region" aria-live="polite" [attr.aria-label]="i18n.t('privacyStorage.bannerLabel')">
    <div class="storage-notice__content">
      <div>
        <p class="storage-notice__eyebrow mb-1">{{ i18n.t('privacyStorage.eyebrow') }}</p>
        <h2 class="h6 mb-1">{{ i18n.t('privacyStorage.title') }}</h2>
        <p class="mb-0 text-secondary">{{ i18n.t('privacyStorage.description') }}</p>
      </div>
      <button type="button" class="btn btn-primary storage-notice__action" (click)="acknowledgeStorageNotice()">
        {{ i18n.t('privacyStorage.acknowledge') }}
      </button>
    </div>
  </section>
}
